module.exports = __webpack_public_path__ + "img/xls.d88323c2.svg";